module.exports = __webpack_public_path__ + "static/img/img_qukuailian_youdian1.4083ab1a.png";